module.exports = __webpack_public_path__ + "img/oppression.0dca536e.png";